/**
 * クリップボードコピー
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business カラーHEX・AI Copy全文のクリップボードコピー。Clipboard API 不在時は false を返す。
 * @graph-connects none
 */
import { logError } from '@cortex/faro';

/**
 * テキストをクリップボードへコピーする。
 * @param text コピーするテキスト
 * @returns 成功したら true
 * @graph-connects none
 */
export async function copyText(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined' || navigator.clipboard === undefined) {
    return false;
  }
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    // 権限拒否等。呼び出し側が false でトースト表示するため Faro に記録して継続する
    logError(error instanceof Error ? error : new Error(String(error)), {
      event: 'clipboard_write_failed',
    });
    return false;
  }
}
